<script>

import cTable from "@/base/common/index.vue";
import {buildApi} from "@/libs/api.request";

export default {
  components: {cTable},
  data() {
    let basicRow = {
      "expense_item": "",
      "goods_type": "",
      "unit_rule": "",
      "price": "",
      "currency": "",
      "start_date": "",
      "expired_date": "",
    }
    return {
      warehouseArray: [],
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                history: this.list,
              });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1200,
              styles: {
                top: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              'from_country': [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              'target_country': [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              'transport_channel': [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {
              title: 8,
              warehouse_name: 16,
              from_country: 8,
              target_country: 8,
              transport_channel: 8
            },
          ],
          fields: [
            {
              key: "title",
              name: () => this.$tz("方案名称"),
              placeholder() {
                return this.$tz("方案名称");
              },
              component: "Input",
            },
            {
              key: "warehouse_name",
              name: () => this.$tz("仓库名称"),
              placeholder() {
                return this.$tz("仓库名称");
              },
              component: "Select",
              options: [],
              optionsFn: "getWarehouse",
              bind: {
                multiple: true
              }
            },
            {
              key: "from_country",
              name: () => '启运国家',
              placeholder() {
                return '请选择启运国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
            {
              key: "target_country",
              name: () => '目的国家',
              placeholder() {
                return '请选择目的国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
            {
              key: "transport_channel",
              name: () => '运输方式',
              placeholder() {
                return '请选择运输方式';
              },
              component: "Select",
              options: [],
              optionsFn: "method",
              optionsKey: "",
              default: "",
            },
          ],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => '收款项目',
                key: "expense_item",
                minWidth: 60,
                component: "Select",
                options: [],
                optionsFn: "getCommon",
                optionsKey: "",
                default: "",
                bind: {
                  align: "left"
                },
                apiData: {
                  apiType: "cost_expense_item"
                }
              },{
                name: () => '货物类型',
                key: "goods_type",
                minWidth: 60,
                component: "Select",
                options: [],
                optionsFn: "getCommon",
                optionsKey: "",
                bind: {
                  align: "left"
                },
                apiData: {
                  apiType: "cargoCategory"
                }
              },{
                name: () => '计费类型',
                key: "unit_rule",
                minWidth: 60,
                component: "Select",
                options: [],
                optionsFn: "getCommon",
                optionsKey: "",
                bind: {
                  align: "left"
                },
                apiData: {
                  apiType: "chargingType"
                }
              },{
                name: () => '价格',
                key: "price",
                minWidth: 60,
                component: "Input",
                bind: {
                  type: "number"
                }
              },{
                name: () => '币种',
                key: "currency",
                minWidth: 60,
                component: "Select",
                options: [],
                optionsFn: "getCurrency",
                optionsKey: "",
                bind: {
                  align: "left"
                },
              },{
                name: () => '有效期始',
                key: "start_date",
                minWidth: 90,
                component: "DatePicker",
                disabledDate: true,
              },{
                name: () => '报价有效期止',
                key: "expired_date",
                minWidth: 90,
                component: "DatePicker",
                disabledDate: true,
              },{
                name: () => this.$t("operation"),
                width: 120,
                render(h, { row, index }) {
                  // 按照序列号返回一个添加的按钮或是删除的按钮
                  let buttons = [];
                  if (index === 0) {
                    // 压入一个增加按钮
                    buttons.push(h("Button", {
                      props: {
                        type: "primary",
                        size: "small",
                        icon: "md-add"
                      },
                      on: {
                        click: () => this.list.push({
                          "expense_item": "",
                          "goods_type": "",
                          "unit_rule": "",
                          "price": "",
                          "currency": "",
                          "start_date": "",
                          "expired_date": "",
                        })
                      }
                    }))
                  } else {
                    // 压入一个删除的按钮
                    buttons.push(h("Button", {
                      props: {
                        type: "error",
                        size: "small",
                        icon: "md-trash"
                      },
                      style: {
                        marginLeft: "5px"
                      },
                      on: {
                        click: () => this.list.splice(index, 1)
                      }
                    }))
                  }
                  return h('div', {}, buttons)
                }
              },
            ],
          }
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("请选择,日期,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "COST_DELIVERY_RULE_DATA_TYPE",
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "fromCountry",
            placeholder() {
              return this.$tz("请选择,启运国家");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
          {
            key: "targetCountry",
            placeholder() {
              return this.$tz("请选择,目的国家");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
          {
            key: "currency",
            placeholder() {
              return this.$tz("请选择,币种");
            },
            component: "Select",
            options: [],
            optionsFn: "getCurrency",
            optionsKey: "",
          },
          {
            name: this.$tz("运输方式"),
            key: "transportCode",
            component: "Select",
            placeholder: () => this.$tz("运输方式"),
            options: [],
            optionsFn: "method",
            optionsKey: "",
            default: "",
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
                this.list.push(basicRow)
              });
            },
          },
        },
      },
      methods: {
        ...buildApi({
          get: [ '/api/costing/index&list',],
          post: ['/api/costing/save', name + '/api/costing/delete/:id&del']
        })
      },
      fields: [
        {
          name: () => this.$tz("报价名称"),
          key: "title",
          minWidth: 180,
        },{
          name: () => this.$tz("起运地"),
          key: "from_country",
          minWidth: 130,
        },{
          name: () => this.$tz("目的港"),
          key: "target_country",
          minWidth: 130,
        },{
          name: () => this.$tz("运输,类型"),
          key: "transport_name",
          minWidth: 140,
        },{
          name: () => this.$tz("仓库名称"),
          key: "warehouse_array",
          minWidth: 180,
        },{
          name: () => this.$tz("创建时间"),
          key: "create_time",
          minWidth: 140,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            update({ row }) {
              this.getModal("add").open(row, function () {
                this.list = row.history;
                this.setTitle(this.$tz("编辑"));
                this.list.push()
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    }
  }
}
</script>

<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<style scoped>

</style>
